import styled from 'styled-components'
import Button from 'components/Button'
import { Link } from 'react-router-dom'

export const ItemImageContainer = styled.div`
  width: 100%;
  height: ${props => props.onlyPicture ? '100%' : '192px'};
  ${props => props.onlyPicture ? 'display: flex; justify-content: center; align-items: center;' : ''}
  margin-bottom: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  @media screen and (min-width: 1100px) {
    height: 142px;

    img {
      width: 130px;
      height: 130px;
      object-fit: contain;
    }
  }

  @media screen and (max-width: 500px) {
    height: ${props => props.onlyPicture ? '100%' : '183px'};
  }
  @media screen and (max-width: 450px) {
    height: ${props => props.onlyPicture ? '100%' : '160px'};
  }
  @media screen and (max-width: 430px) {
    height: ${props => props.onlyPicture ? '100%' : '149px'};
  }
  @media screen and (max-width: 410px) {
    height: ${props => props.onlyPicture ? '100%' : '139px'};
  }
  @media screen and (max-width: 390px) {
    height: ${props => props.onlyPicture ? '100%' : '129px'};
  }
  @media screen and (max-width: 370px) {
    height: ${props => props.onlyPicture ? '100%' : '119px'};
  }
  @media screen and (max-width: 350px) {
    height: ${props => props.onlyPicture ? '100%' : '108px'};
  }
  @media screen and (max-width: 330px) {
    height: ${props => props.onlyPicture ? '100%' : '100px'};
  }
`
export const SpecialTagContainer = styled.div`
  /* height: 30px; */
  width: 100%;
  display: flex;
  justify-content: center;
  @media screen and (max-width: 1099px){
    height: 25px;
    margin-bottom: 10px;
  }
`
export const SalePercentage = styled.div`

    position: absolute;
    bottom: ${props => props.productItem ?  "-10px" : "0px"};
    font-size: 12px;
    left: ${props => props.productItem ?  0 : ""};
    right: ${props => props.productItem ?  "" : "150px"};
    background: linear-gradient(to right top, #ff4b2b, #ff453e, #ff424e, #ff405d, #ff416c);
    color: white;
    padding: 2px 8px;
    border-radius: 20px;
    font-weight: bold;
    letter-spacing: 0.8px;
`

export const CardContainer = styled.div`
  background: #F7FAFC;
  margin-top: 20px;
  border-radius: 10px;
  padding: 14px;
  border: 1px solid red;
`

export const SpecialTag = styled.div`
  height: 100%;
  color: white;
  display: flex;
  align-items: center;
  padding: 2px 5px;
  font-size: 12px;
  border-radius: 5px;
  font-family: ${props=> props.theme.font.family.medium};
  font-weight: lighter;
  text-align: center;
  ${props=> (props.type === "fast")? "background-image: linear-gradient(to right top, #d658e8, #c745ec, #b431f2, #9d1cf8, #7f00ff);":""};
  ${props=> (props.type === "sale")? "background-image: linear-gradient(to right top, #ff4b2b, #ff453e, #ff424e, #ff405d, #ff416c);":""};
  ${props=> (props.type === "top")? "background-image: linear-gradient(to right top, #b2de00, #40bd00);":""};
  ${props=> (props.type === "last")? "background-image: linear-gradient(84.78deg, #FF7E00 0%, #FF2000 100%)":""};
  ${props=> (props.type === "gift")? "background-image: linear-gradient(84.78deg, #162131 0%, #162139 100%)":""};

  @media screen and (max-width: 1099px){
  font-size: 11px;
  }
  
  svg{
    margin-right: 5px;
  }
  white-space: nowrap;
  
  
  
`

export const ItemPrice = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: center;
  margin-bottom: 7px;

  img {
    margin-right: 6px;
  }

  .out-of-stock {
    font-size: 13px;
    padding-bottom: 5px;
  }

  p, .price-icon {
    font-size: 18px;
    font-family: ${props => props.theme.font.family.medium};
    font-weight: bolder;
    border-radius: 5px;
    color: ${props => props.theme.color.red};

    span {
      display: inline-block;
      margin-left: 3px;
      text-decoration: none;
    }
  }

  span {
    font-size: 15px;
    color: #747474;
    margin-left: 5px;
    letter-spacing: -0.28px;
    text-decoration: line-through;
    display: inline-block;
    position: relative;
    font-family: Roboto-Medium;
  }

  @media screen and (min-width: 1100px) {
    p, .price-icon {
      font-size: 21px;
    }

    span {
      font-size: 16px;
    }

    .out-of-stock {
      font-size: 15px;
      padding-bottom: 6px;
    }

    @media screen and (max-width: 1399px) {
      .out-of-stock {
        padding-top: 2px;
        font-size: 13px;
        padding-bottom: 6px;
      }
    }
    @media screen and (max-width: 1249px) {
      .out-of-stock {
        padding-top: 8px;
        font-size: 11px;
        padding-bottom: 6px;
      }
    }


  }
`

export const FreshItemPrice = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  margin-bottom: 7px;
  width: 40%;

  img {
    margin-right: 6px;
  }

  .out-of-stock {
    font-size: 15px;
  }

  p, .price-icon {
    font-size: 18px;
    font-weight: bold;
    font-family: ${props => props.theme.font.family.medium};
    margin-right: 4px;
    border-radius: 5px;
    color: #EB3E3E;

    span {
      display: inline-block;
      margin-left: 3px;
      text-decoration: none;
    }
  }

  span {
    font-size: 13px;
    color: #747474;
    letter-spacing: -0.28px;
    text-decoration: line-through;
    display: inline-block;
    position: relative;
    font-family: ${props => props.theme.font.family.medium};
  }

  @media screen and (min-width: 1100px) {
    p, .price-icon {
      font-size: 21px;
    }

    span {
      font-size: 16px;
    }
  }
`

export const ItemImage = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;

  img {
    display: block;
    position: absolute;
    width: 12rem;
    max-height: 100%;
    transition: opacity 0.4s ease-in-out;
  }


  @media screen and (min-width: 1100px) {
    img {
      width: 130px;
    }

    &.hovered {
      .second-image {
        opacity: 0;
      }


      &:hover {
        img {
          opacity: 0;
        }

        .second-image {
          opacity: 1;
        }
      }
    }
  }
`

export const ItemName = styled.h2`
  color: ${props => props.theme.color[props.color]};
  font-family: ${props => props.theme.font.family.regular};
  font-size: 13px;
  margin-top: 7px;
  font-weight: lighter;
  overflow: hidden;
  height: 70px;
  -webkit-box-orient: vertical;
  transition: 0.3s;
  margin-bottom: 0;
  @media screen and (min-width: 1100px) {
    margin-top: 10px;
    font-size: 15px;
  }
`

export const ItemFavorite = styled.div`
  position: absolute;
  top: 20px;
  right: 15px;
  z-index: 99;
  cursor: pointer;

  svg {
    width: 14.48px;
    height: 12.54px;
  }

  @media screen and (min-width: 1100px) {
    right: 20px;
    svg {
      width: unset;
      height: unset;
    }
  }
`

export const AddFavoriteButton = styled(Button)`
  margin-top: 15px;
  position: absolute;
  z-index: 100;
  opacity: 0;
  transition: 0.3s;
  @media screen and (min-width: 1100px) {

  }
`

export const ProductItemContainer = styled(Link)`
  background-color: ${props => props.theme.color.white};
  text-decoration: none;
  border-radius: 6px;
  box-shadow: 0 3px 15px 0 rgba(219, 212, 212, 0.15);
  border: 1px solid ${props => props.theme.color.greyED};
  ${props => props.istop ? `border: 1px solid ${props.theme.color.orange}` : ''}
  display: flex;
  flex-direction: column;
  padding: 5px;
  position: relative;
  transition: 0.3s;
  height: fit-content;

  ${props =>
    props['data-nostock'] &&
    `
    -webkit-filter: grayscale(100%);
    filter: grayscale(100%);
    // opacity: 0.6;
  `}

  @media screen and (min-width: 1100px) {
    padding: 20px 10px 5px 10px;
  }

  @media screen and (min-width: 1100px) {
    ${props => !props.nohover && '&:hover { transform: scale(1.1, 1.1); transition: 0.3s;}'}
  }
  .product-item {
    position: relative; 
    overflow: hidden; 
    z-index: 10;
  }
  
  .cart-wishlist-container{
    display: flex;
    justify-content: space-between;
    width: 100%;
    align-items: center;

  }

   .mobile-cart-container {
    display:flex;
    align-items: center;
    align-self: flex-end;
    padding: 8px;
    border-radius: 4px;
    background: #F2F4F5;
    font-size: 12px;
    margin-bottom: 6px;
    margin-top: 4px;
    color: black;
    gap: 5px;
  }

  .mobile-buy-container {
    display:flex;
    align-items: center;
    align-self: flex-end;
    padding: 8px;
    border-radius: 4px;
    background: linear-gradient(to right top, #ff4b2b, #ff453e, #ff424e, #ff405d, #ff416c);
    font-size: 12px;
    margin-bottom: 6px;
    margin-top: 4px;
    color: white;
    gap: 5px;
  }
  .cart-container {
    position: absolute;
    right: -10px; 
    top: 10%;
    transition: all 0.3s ease; 
    opacity: 0;
    display: flex;
    background-color: gainsboro;
    padding: 10px;
    border-radius: 5px;
    cursor: pointer;
  }

  &:hover .cart-container {
    right: 10px;
    opacity: 1; 
    pointer-events: auto; 
    z-index: 999;
  }
  .stars-and-name {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
  }
`

export const TopCircle = styled.div`
  width: 39px;
  height: 39px;
  border-radius: 100%;
  background-color: ${props => props.theme.color.orange};
  color: white;
  font-size: 12px;
  text-align: center;
  line-height: 39px;
  text-transform: uppercase;

  position: absolute;
  left: 16px;
  top: 16px;
  z-index: 10;
`
